import { render } from "./customFunctionEditor.vue?vue&type=template&id=f61a9134&scoped=true"
import script from "./customFunctionEditor.vue?vue&type=script&lang=js"
export * from "./customFunctionEditor.vue?vue&type=script&lang=js"

import "./customFunctionEditor.vue?vue&type=style&index=0&id=f61a9134&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61a9134"]])

export default __exports__